import { Grid, Modal } from '@mui/material';
import { makeStyles } from 'tss-react/mui';
import {
  BasicTable,
  Button,
} from '@HomaHealth/ui-component-library/lib/_AIQ-components';
import { Typography } from '@HomaHealth/ui-component-library/lib/_patient-access-components';

import { patientAccessTheme } from '@HomaHealth/ui-component-library/lib/theme/theme';
import React from 'react';
import componentConstants from '../../../core-utils/messages/componentConstants';
import { Columns } from '@HomaHealth/ui-component-library/lib/_AIQ-components/atoms/BasicTable';
import Hands from '../../atoms/Icons/Hands';

export const cellStyles4 = {
  color: patientAccessTheme.palette.text.mediumemphasis,
  fontSize: '14px',
  fontWeight: 400,
};

export interface AcceptCaseModalProps {
  open: boolean;
  handleClose: () => any;
  handleSave: () => any;
  isSaveButtonDisabled: boolean;
  columns: Columns[];
  rowsData: any;
}

const AcceptCaseModal: React.FC<AcceptCaseModalProps> = ({
  open,
  handleClose,
  handleSave,
  isSaveButtonDisabled,
  columns,
  rowsData,
}) => {
  const useStyles = makeStyles()({
    modal: {
      width: '553px',
      height: '370px',
      background: patientAccessTheme.palette.status.white,
      borderRadius: '8px',
      padding: '24px 24px 24px 32px',
      position: 'absolute',
      top: '50%',
      left: '50%',
      transform: 'translate(-50%, -50%)',
      flexDirection: 'column',
    },
    alignCenter: {
      textAlign: 'center',
    },
    cancelButton: {
      padding: '9px 16px',
      width: '102px',
      height: '36px',
      border: '1px solid ' + patientAccessTheme.palette.primary[500],
      borderRadius: '4px',
      textTransform: 'none',
      fontSize: '12px',
      lineHeight: '12px',
      fontWeight: 500,
    },
    saveButton: {
      padding: '9px 16px',
      width: '158px',
      height: '36px',
      border:
        '1px solid ' + isSaveButtonDisabled
          ? patientAccessTheme.palette.grey[500]
          : patientAccessTheme.palette.primary[500],
      borderRadius: '4px',
      textTransform: 'none',
      fontSize: '12px',
      lineHeight: '12px',
      fontWeight: 500,
    },
  });
  const { classes } = useStyles();
  const constants = componentConstants.ORGANISMS.CARE_NAV_MODALS.ACCEPT_MODAL;

  return (
    <Modal open={open} onClose={handleClose}>
      <Grid container className={classes.modal}>
        <Grid className={classes.alignCenter}>
          <Hands />
        </Grid>
        <Grid className={classes.alignCenter}>
          <Typography
            fontSize="18px"
            lineHeight="26px"
            fontType="semibold"
            textColor={patientAccessTheme.palette.text.highemphasis}
            margin="10px 0px 0px 0px"
          >
            {constants.TITLE}
          </Typography>
          <Typography
            fontSize="14px"
            lineHeight="24px"
            fontType="normal"
            textColor={patientAccessTheme.palette.text.mediumemphasis}
            margin="5px 0px 10px 0px"
          >
            {constants.SUB_TITLE}
          </Typography>
        </Grid>

        <Grid>
          <BasicTable
            width={'490px'}
            displayType={'box'}
            columns={columns}
            rowsData={rowsData}
            headerTextColor={patientAccessTheme.palette.status.white}
            headerColor={patientAccessTheme.palette.grey[700]}
            borderRadius="4px"
          />
        </Grid>

        <Grid
          container
          style={{
            position: 'absolute',
            bottom: 0,
            display: 'flex',
            flexDirection: 'row',
            justifyContent: 'center',
            marginLeft: '-32px',
            marginBottom: '24px',
          }}
          sx={{
            alignItems: 'center',
          }}
        >
          <Grid style={{ marginRight: '12px' }}>
            <Button
              label={constants.CANCEL}
              variant="outlined"
              className={classes.cancelButton}
              onClick={handleClose}
            />
          </Grid>
          <Grid>
            <Button
              width="158px"
              label={constants.SUBMIT}
              variant="contained"
              className={classes.saveButton}
              disabled={isSaveButtonDisabled}
              onClick={() => {
                handleSave && handleSave();
              }}
            />
          </Grid>
        </Grid>
      </Grid>
    </Modal>
  );
};
export default AcceptCaseModal;
